import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useStores } from 'store';
import * as HmiFiles from '../../../hmilib/hmifiles';
import '../../../hmilib/hmiglobal';
import { TypeSystemEnum } from '../../../hmilib/hmiglobal';
import * as ExperionScript from '../../../hmilib/hooks/ExperionScript';
import LoadPage from './../../LoadPage';
import BottomMenu from './BottomMenu';
import './experion.css';
import TopMenu from './TopMenu';

interface imain {}

const Main = (props: imain) => {
    const { SystemStore } = useStores();
    const [loadstate, setLoadState] = React.useState(false);

    const [NumInst, setNumInst] = React.useState<string>('');
    const [NameState, setNameState] = React.useState<string>('');
    const [TrenName, setTrenName] = React.useState<string>('');

    React.useEffect(() => {
        let pagename = 'Experion';

        window.TypeSystem = TypeSystemEnum.ExperionPks;

        document.title = pagename + ': ' + NumInst + '. ' + TrenName + ' (' + NameState + ')';

        return function clear() {
            HmiFiles.CloseAll();
        };
    }, [NumInst, NameState, TrenName]);

    React.useEffect(() => {
        if (SystemStore.loadState) {
            ExperionScript.InitExperionPksSetting();
            setLoadState(true);
        }
    }, [SystemStore.loadState]);

    if (!loadstate) {
        return <LoadPage />;
    } else {
        return (
            <div className="experion">
                <TopMenu />
                <div id="main" className="experion-main">
                    <iframe id="mainframe" name="mainframe" className="experion-main__frame"></iframe>
                </div>

                <BottomMenu />
            </div>
        );
    }
};

export default observer(Main);
